import React from 'react'


function FooterBot() {
    return(
        <div className='container-fluid FooterBot'>
            <div className="row ">
                <span >2021 © My Pocket LLC</span>
            </div>

        </div>
    )
}
export default FooterBot;